/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { LowestPriceForFlights } from '../../models/lowest-price-for-flights';

export interface GetPricesForFlights$Params {

/**
 * IATA codes for airports, cities
 */
  departureLocationCodes: Array<string>;

/**
 * IATA codes for airports, cities
 */
  destinationLocationCodes: Array<string>;

/**
 * Show prices starting from this date (yyyy-MM-dd)
 */
  departureDate?: string;

/**
 * Number of days to search forward from given start date
 */
  numberOfDays?: number;

/**
 * Length of stay
 */
  lengthOfStay?: string;

/**
 * Travel classes
 */
  travelClasses?: Array<string>;

/**
 * Request oneway trip
 *
 * @deprecated
 */
  oneway?: boolean;

/**
 * Trip types
 */
  tripTypes?: Array<string>;

/**
 * locale
 */
  locale?: string;
}

export function getPricesForFlights(http: HttpClient, rootUrl: string, params: GetPricesForFlights$Params, context?: HttpContext): Observable<DapiHttpResponse<LowestPriceForFlights>> {
  const rb = new DapiRequestBuilder(rootUrl, getPricesForFlights.PATH, 'get');

  if (params) {
    rb.query('departureLocationCodes', params.departureLocationCodes, {"explode":false});
    rb.query('destinationLocationCodes', params.destinationLocationCodes, {"explode":false});
    rb.query('departureDate', params.departureDate, {});
    rb.query('numberOfDays', params.numberOfDays, {});
    rb.query('lengthOfStay', params.lengthOfStay, {});
    rb.query('travelClasses', params.travelClasses, {"explode":false});
    rb.query('oneway', params.oneway, {});
    rb.query('tripTypes', params.tripTypes, {"explode":false});
    rb.query('locale', params.locale, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<LowestPriceForFlights>;
    }),
    catchErrorAsJson()
  );
}

getPricesForFlights.PATH = '/api/instantsearch/prices/flights';
